import React, {
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import ReactTimer from 'react-compound-timer';
import moment from 'moment';

import i18n from '../../../config/i18n';

const TIME_PER_PERIOD = 15 * 60 * 1000;
const TIME_TO_REMIND = 2 * 60 * 1000;
const TIME_IS_UP = 0;
const MAX_PERIOD_COUNT = 24 * (60 / 15);
const timerAlert = 'timer-alert';
const timerNormal = 'timer-normal';


const Timer = ({
  actions,
  createdAt,
}) => {
  const passedTime = moment() - moment(createdAt);
  const [initialTime, setInitialTime] = useState(TIME_PER_PERIOD - (passedTime % TIME_PER_PERIOD));
  const [periodCount, setPeriodCount] = useState(Math.floor(passedTime / TIME_PER_PERIOD));
  const [isTimeUp, setIsTimeUp] = useState(initialTime <= TIME_IS_UP);
  const [className, setClassName] = useState(
    initialTime < TIME_TO_REMIND ? timerAlert : timerNormal
  );

  // Set the initial time to TIME_PER_PERIOD so that new timers except
  // the first one will start from TIME_PER_PERIOD.
  useEffect(() => setInitialTime(TIME_PER_PERIOD), []);
  useEffect(() => {
    if (isTimeUp) {
      const timer = setTimeout(() => {
        setPeriodCount(periodCount + 1);

        // The tokbox token will expire 24 hours later after created
        // so we need to force user to exit video chat.
        if (periodCount >= MAX_PERIOD_COUNT - 1) {
          actions.createWarningAlert(i18n.t(['videoChat', 'timeLimitReminder']));
          window.history.back();
        }
        setClassName(timerNormal);
        setIsTimeUp(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
    return undefined;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTimeUp]);

  const formatValue = value => (value < 10 ? `0${value}` : `${value}`);

  const createTimer = () => {
    const subStrings = i18n.t(['videoChat', 'hadSession'], {
      count: periodCount,
      rank: i18n.t(['videoChat', 'rank', (periodCount + 1) % 10], { count: periodCount + 1 }),
    }).split('TIMER');
    return (
      [
        subStrings[0],
        <ReactTimer
          key="timer"
          direction="backward"
          initialTime={initialTime}
          formatValue={formatValue}
          checkpoints={[
            {
              time: TIME_TO_REMIND,
              callback: () => setClassName(timerAlert),
            },
            {
              time: TIME_IS_UP,
              callback: () => setIsTimeUp(true),
            },
          ]}
        >
          <ReactTimer.Minutes />:<ReactTimer.Seconds />
        </ReactTimer>,
        subStrings[1],
      ]
    );
  };

  return (
    <div className={className}>
      {isTimeUp ? i18n.t(['videoChat', 'timeIsUp']) : createTimer()}
    </div>
  );
};

Timer.propTypes = {
  actions: PropTypes.shape({
    createWarningAlert: PropTypes.func.isRequired,
  }).isRequired,
  createdAt: PropTypes.string.isRequired,
};

Timer.defaultProps = {};


export default Timer;



// WEBPACK FOOTER //
// ./src/components/messaging/videoChat/Timer.js